import React from 'react';
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import { Container, Header, Image, Segment, Portal } from 'semantic-ui-react';

import './styles.css'
import CupCard from './Drive/Cards/CupCard';
import InitiativeBox from './DesignerPane/InitiativeBox';
import CommunityBox from './DesignerPane/CommunityBox';
import PlaybookBox from './DesignerPane/PlaybookBox';
import ContentBox from './DesignerPane/ContentBox';
import EventStream from './DesignerPane/EventStream';
import { source } from 'react-aim';
import HomeImage from '../../../images/grafix-banner/initiativesPage.svg';
import EventDetailsNotFound from './Drive/Modal/EventDetailsNotFound';
import { HelpComponent } from "../../common/HelpComponent";

@source({
  mouseEnter: (props, component) => {
    dispatch.app.setHelpContext("Clock and Timezone")
  }
})

class Home extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoadingData: true,
      log: [],
      logCount: 0,
      open: false,
    }
  }

  async componentWillMount() {
    dispatch.notifications.setFilterQueryData({})
    dispatch.account.getAllAccounts(this.props.user._id);
    dispatch.app.setCurrentContext("home");
    dispatch.home.eventDetailsNotFound(false);
    dispatch.notifications.setEventStreamData(null);
    dispatch.notifications.getEventStreamByOrganization({});
  }
  async componentDidMount() {
    if (this.props.selectedOrganisation && this.props.selectedOrganisation.role !== "Member") {
      let payload = {}
      payload.organizationId = this.props.match.params.workspaceId
      dispatch.initiatives.getinitiativesCountProxy(payload);
      dispatch.lifeCycle.getCounts({ id: this.props.match.params.workspaceId, isOwner: this.props.selectedOrganisation.role === 'workspaceOwner' ? true : false })
      dispatch.content.getContentsCount({ organizationId: this.props.match.params.workspaceId })
      if (this.props.selectedOrganisation && this.props.selectedOrganisation.role === 'workspaceOwner') {
        dispatch.organizationUnit.getOrganizationCount({ organizationId: this.props.match.params.workspaceId, accountId: this.props.match.params.accountId })
      }
      else if (this.props.selectedOrganisation && this.props.selectedOrganisation.role === 'Manager') {
        dispatch.organizationUnit.myCommunityDashboardCount({ organizationId: this.props.match.params.workspaceId, accountId: this.props.match.params.accountId })
      }
    }
    dispatch.organizationTab.getCurrentOrganizationData(this.props.selectedOrganisation.id);
    await dispatch.organizationTab.getUsersTreeAsync({ id: this.props.selectedOrganisation.id, accountId: this.props.selectedAccount._id });
    // await dispatch.lifeCycle.getPlaybookById(this.props.selectedOrganisation.id);
    



  }
  componentWillReceiveProps(nextProps) {
    if (this.props.selectedOrganisation && this.props.selectedOrganisation.role !== "Member") {
      if (nextProps.selectedOrganisation && this.props.selectedOrganisation && this.props.selectedOrganisation.id !== nextProps.selectedOrganisation.id) {
        let payload = {}
        payload.organizationId = nextProps.selectedOrganisation.id
        dispatch.initiatives.getinitiativesCountProxy(payload);
        dispatch.lifeCycle.getCounts({ id: nextProps.selectedOrganisation.id })
        dispatch.content.getContentsCount({ organizationId: nextProps.selectedOrganisation.id })
        if (nextProps.selectedOrganisation && nextProps.selectedAccount && nextProps.selectedOrganisation.role === 'workspaceOwner') {
          dispatch.organizationUnit.getOrganizationCount({ organizationId: nextProps.selectedOrganisation.id, accountId: nextProps.selectedAccount._id })
        }
        else if (nextProps.selectedOrganisation && nextProps.selectedAccount && nextProps.selectedOrganisation.role === 'Manager') {
          dispatch.organizationUnit.myCommunityDashboardCount({ organizationId: nextProps.selectedOrganisation.id, accountId: nextProps.selectedAccount._id })
        }
      }
    }
  }

  handleOpen = () => {
    this.setState({ open: true })
    this.writeLog('onOpen()')
  }

  handleClose = () => {
    this.setState({ open: false })
    this.writeLog('onClose()')
  }

  clearLog = () => this.setState({ log: [], logCount: 0 })

  writeLog = (eventName) =>
    this.setState((prevState) => ({
      log: [
        `${new Date().toLocaleTimeString()}: ${eventName}`,
        ...prevState.log,
      ].slice(0, 20),
      logCount: prevState.logCount + 1,
    }))


  render() {
    const InitiativeCard = <InitiativeBox
      intitiativeCountData={this.props.intitiativeCountData}
      selectedOrganisation={this.props.selectedOrganisation}
      history={this.props.history}
      isLoadingData={this.state.isLoadingData}
      user={this.props.user}
      loadingInitiative={this.props.loadingInitiative}

    />

    const communityCard = <CommunityBox
      allOrgUsers={this.props.executiveList.length+this.props.managerList.length+this.props.memberList.length}
      organizationCountData={this.props.organizationCountData}
      selectedOrganisation={this.props.selectedOrganisation}
      selectedAccount={this.props.selectedAccount}
      history={this.props.history}
      isLoadingData={this.state.isLoadingData}
      user={this.props.user}
      loadingOrganization={this.props.loadingOrganization}
      loadingMyOrganization={this.props.loadingMyOrganization}
    />

    const playbookCard = <PlaybookBox
      selectedAccount={this.props.selectedAccount}
      packCount={this.props.packCount}
      selectedOrganisation={this.props.selectedOrganisation}
      history={this.props.history}
      isLoadingData={this.state.isLoadingData}
      user={this.props.user}
      loadingPlaybook={this.props.loadingPlaybook}
    />

    const contentCard = <ContentBox
      contentCountData={this.props.contentCountData}
      selectedOrganisation={this.props.selectedOrganisation}
      history={this.props.history}
      isLoadingData={this.state.isLoadingData}
      user={this.props.user}
      loadingContent={this.props.loadingContent}
    />


    let portal = <Portal
      closeOnTriggerClick
      openOnTriggerClick

      onOpen={this.handleOpen}
      onClose={this.handleClose}
    >
      <Segment
        style={{
          left: '90px',
          position: 'fixed',
          bottom: '10px',
          zIndex: 1000,
          width: "300px"
        }}
      >
        <HelpComponent />
      </Segment>
    </Portal>

    return (
      <div style={{ display: "flex", overflow: 'auto' }}>
        {this.props.selectedOrganisation && this.props.selectedOrganisation.role !== "Member" ?
          <div className="home-container">
            <div className=" left-block">
              <div className="dashboard-block">
                <CupCard
                  user={this.props.user}
                  intitiativeCountData={this.props.intitiativeCountData}
                  loaderDashboard={this.props.loaderDashboard}
                  {...this.props}
                />
              </div>
              <div className="dashboard-block">
                {InitiativeCard}
              </div>
              <div className="dashboard-block">
                {communityCard}
                {portal}
              </div>
              <span className="showBlock">
                <div className="dashboard-block ">
                  {playbookCard}
                </div>
                <div className="dashboard-block ">
                  {contentCard}
                </div>
              </span>

            </div>
            <div className="dashboard-block middle-block mar_tb_10">
              <EventStream
                eventStreamArray={this.props.eventStreamArray}
                loaderEventData={this.props.loaderEventData}
                selectedOrganisation={this.props.selectedOrganisation}
                notificationsCount={this.props.notificationsCount}
                selectedAccount={this.props.selectedAccount}
                initiativeOwnerDetails={this.props.initiativeOwnerDetails}
                filterQuery={this.props.filterQuery}
                noEventDataFound={this.props.noEventDataFound}
                currentOrganization={this.props.currentOrganization}
                user={this.props.user}
                singlePlaybookEntry={this.props.singlePlaybookEntry}

              />
            </div>
            <div className="right-block ">
              <div className="dashboard-block">
                {playbookCard}
              </div>
              <div className="dashboard-block">
                {contentCard}
              </div>
            </div>
          </div>
          :
          <Container className="demoImage">
            <Header as='h2' icon textAlign='center'>
              <Header.Content>
                Home
          </Header.Content>
            </Header>
            <Image src={HomeImage} size='large' centered={true} />
          </Container>}

        <EventDetailsNotFound
          open={this.props.noEventDataFound}
        />
      </div>
    );
  }
}


function mapStateToProps(state) {

  return {
    selectedOrganisation: state.app.selectedOrganisation,
    user: state.app.user,
    executiveList: state.users.executiveList,
    managerList: state.users.managerList,
    memberList: state.users.memberList,
    intitiativeCountData: state.initiatives.intitiativeCountData,
    loadingInitiative: state.loading.effects.initiatives.getinitiativesCountProxy && state.loading.models.initiatives,
    packCount: state.lifeCycle.packCount,
    loadingPlaybook: state.loading.effects.lifeCycle.getCounts && state.loading.models.lifeCycle,
    contentCountData: state.content.contentCountData,
    loadingContent: state.loading.effects.content.getContentsCount && state.loading.models.content,
    organizationCountData: state.organizationUnit.organizationCountData,
    loadingOrganization: state.loading.effects.organizationUnit.getOrganizationCount && state.loading.models.organizationUnit,
    loadingMyOrganization: state.loading.effects.organizationUnit.myCommunityDashboardCount && state.loading.models.organizationUnit,
    selectedAccount: state.app.selectedAccount,
    eventStreamArray: state.notifications.eventStreamArray,
    loaderEventData: state.loading.effects.notifications.getEventStreamByOrganization && state.loading.models.notifications,
    notificationsCount: state.notifications.notificationsCount,
    initiativeOwnerDetails: state.initiatives.initiativeOwnerDetails,
    noEventDataFound: state.home.noEventDataFound,
    loaderDashboard: state.loading.effects.initiatives.getinitiativesCount,
    filterQuery: state.notifications.filterQuery,
    envData: state.app.envData,
    currentOrganization:state.organizationTab.currentOrganization,
    allPlaybooksByUserIdAndTeamId: state.lifeCycle.allPlaybooksByUserIdAndTeamId,
    singlePlaybookEntry:state.lifeCycle.singlePlaybookEntry,
    teamToExport:state.organizationUnit.teamToExport
  };
}

const connectedDashboardPage = connect(mapStateToProps)(Home);
export { connectedDashboardPage as Home };


